import React, { useEffect, useState } from "react";
import Template from "../utils/Template";
import Card from "../utils/Card";
import TableScroll from "../utils/TableScroll";
import { Table, TableBody, TableHeader } from "../utils/Table";
import Pagination from "../utils/Pagination";
import { decodeData, errorToaster } from "../utils/Helper";
import { useNavigate } from "react-router-dom";
import SubmitBtn from "../utils/SubmitBtn";
import DateRangeFormat from "../utils/DateRangeFormat";
import { getMethod } from "../service";
import ConfirmModal from "../utils/modals/ConfirmModal";
import { USER_BETS_API } from "../service/constant";
import moment from "moment";
import Input from "../utils/Input";

const BetLists = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const [bettings, setBettings] = useState([]);
  const [from, setFrom] = useState(1);
  const [refs, setRefs] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const navigate = useNavigate();
  const [showDetail, setShowDetail] = useState(false);
  const [detailData, setDetailData] = useState("");
  const [betDetail, setBetDetail] = useState("");
  const [searchId, setSearchId] = useState("");

  const fetchBetting = async () => {
    setIsLoading(true);
    const token = decodeData(localStorage.getItem("r_c_a"));
    if (token) {
      const res = await getMethod(
        `${USER_BETS_API}?page=${page}&limit=50&start_date=${startDate}&end_date=${endDate}&search=${searchId}`,
        token.token
      );
      if (res?.isSuccess) {
        setIsLoading(false);
        setBettings(res?.data);
        setFrom((res?.meta?.current_page - 1) * 50);
        setTotalPage(res?.meta?.last_page);
      } else {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
      errorToaster("Unauthenticated!");
      setTimeout(() => {
        navigate("/login");
      }, 100);
    }
  };

  useEffect(() => {
    fetchBetting();
  }, [refs, page]);

  useEffect(() => {
    let result = detailData.split("-[").map((el) => {
      return el.split("]")[1];
    });
    result = result.filter((el) => el !== "");
    setBetDetail(result);
  }, [detailData]);

  return (
    <Template title={"Bet Lists"} isLoading={isLoading}>
      <Card>
        <div className="row d-flex justify-content-end">
          <div className="col-12 col-md-4 px-1">
            <Input
              type="text"
              value={searchId}
              event={(e) => setSearchId(e.target.value)}
              placeholder="Search User Name OR Phone"
            />
          </div>

          <div className="col-12 col-md-4 px-1 mb-3">
            <DateRangeFormat
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
          </div>
          <div className="col-12 col-md-4 px-1 mb-3">
            <SubmitBtn
              type="submit"
              name="Search"
              event={() => setRefs(!refs)}
              isLoading={isLoading}
            />
          </div>
        </div>
        <TableScroll>
          <Table>
            <TableHeader>
              <th>No.</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Bet Number</th>
              <th>Bet Amount</th>
              <th>Bet Time</th>
            </TableHeader>
            <TableBody>
              {bettings.length > 0 &&
                bettings.map((betting, i) => (
                  <tr key={betting._id}>
                    <td>{i + from + 1}</td>
                    <td>{betting?.name || betting?.userId?.name}</td>
                    <td>{betting?.phone || betting?.userId?.phone}</td>
                    <td className="text-center">{betting.betNumber}</td>
                    <td className="text-end">
                      {betting.amount.toLocaleString("en-us")}
                    </td>
                    <td>
                      {moment(betting.createdAt)
                        .utc()
                        .format("DD-MM-YYYY, hh:mm:ss A")}
                    </td>
                  </tr>
                ))}
            </TableBody>
          </Table>
        </TableScroll>
        {totalPage > 1 && (
          <div className="d-flex justify-content-end">
            <Pagination
              setPage={setPage}
              setIsLoading={setIsLoading}
              totalPage={totalPage}
            />
          </div>
        )}
      </Card>
      {showDetail && (
        <ConfirmModal
          name={"Bet Detail"}
          isLoading={isLoading}
          onClose={() => {
            setShowDetail(false);
            setDetailData("");
            setBetDetail("");
          }}
          onSubmit={() => {
            setShowDetail(false);
            setDetailData("");
            setBetDetail("");
          }}
        >
          <ul>
            {betDetail.length > 0 &&
              betDetail.map((detail, i) => <li key={i}>{detail}</li>)}
          </ul>
        </ConfirmModal>
      )}
    </Template>
  );
};

export default BetLists;
